import React, {
    useEffect,
    useState,
} from 'react'

export const DateTime = () => {
    const [dateTime, setDateTime] = useState()

    useEffect(() => {
        const timeInterval = setInterval(() => {
            setDateTime(window.moment?.())
        }, 1000)

        return () => clearInterval(timeInterval)
    }, []);

    return (
        <div
            className="d-flex flex-column w-100 align-content-center justify-content-center align-items-center pt-3 mt-3"
            style={{
                borderTop: '1px solid #3a3a3a',
            }}
        >
            <div style={{ fontSize: '40px', color: '#ffffff'}}>
                {dateTime?.format('l')}
            </div>
            <div style={{ fontSize: '60px', color: '#ffffff', fontWeight: 'bold' }}>
                {dateTime?.format('LTS')}
            </div>
        </div>
    )
}
